import React, { memo, useState } from "react";
import shipmentStylez from "./ShipmentCard.module.css";
import { AiOutlineClose } from "react-icons/ai";
import Select from "react-select";
import { FaTrash } from "react-icons/fa";

const ShipmentCard = (props) => {
  const {
    formData,
    setFormData,
    stock,
    product,
    productArr,
    setProduct,
    setProductArr,
  } = props.data;

  const [editedQuantities, setEditedQuantities] = useState({});
  // ✅ ADD: Local state for quantity input
  const [localQuantity, setLocalQuantity] = useState("");

  const productOptions = props.data.prodOptions?.map((i) => ({
    value: i._id,
    label: `${i.productName}-${i.sku}`,
  }));

  const handleInput = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleChange = (e) => {
    setProduct(e.value);
  };
  const deleteData = (indexp) => {
    setProductArr(productArr.filter((i, index) => index !== indexp));
  };
  const handleQuantityEdit = (index, newValue) => {
    const updatedQuantities = { ...editedQuantities, [index]: newValue };
    setEditedQuantities(updatedQuantities);

    const updatedProductArr = props.data.productArr.map((item, i) => {
      if (i === index) {
        return { ...item, quantity: newValue };
      }
      return item;
    });
    props.data.setProductArr(updatedProductArr);
  };

  // ✅ NEW: State for managing multiple containers
  const [containers, setContainers] = useState([
    {
      id: Date.now(),
      containerNumber: "",
      sealNumber: "",
      vessel: "",
      items: [],
    },
  ]);
  const [currentContainer, setCurrentContainer] = useState(0);

  // ✅ NEW: Handle container-specific field changes
  const handleContainerChange = (containerIndex, field, value) => {
    const updatedContainers = containers.map((container, index) => {
      if (index === containerIndex) {
        return { ...container, [field]: value };
      }
      return container;
    });
    setContainers(updatedContainers);
  };

  // ✅ NEW: Add new container
  const addContainer = () => {
    const newContainer = {
      id: Date.now() + Math.random(),
      containerNumber: "",
      sealNumber: "",
      vessel: "",
      items: [],
    };
    setContainers([...containers, newContainer]);
    setCurrentContainer(containers.length); // Switch to new container
  };

  // ✅ NEW: Remove container
  const removeContainer = (containerIndex) => {
    if (containers.length > 1) {
      const updatedContainers = containers.filter(
        (_, index) => index !== containerIndex
      );
      setContainers(updatedContainers);
      if (currentContainer >= updatedContainers.length) {
        setCurrentContainer(updatedContainers.length - 1);
      }
    }
  };

  // ✅ NEW: Add product to specific container
  const addProductToContainer = () => {
    if (!product || !localQuantity || localQuantity <= 0) return;

    const newItem = {
      product: product,
      quantity: Number(localQuantity),
    };

    const updatedContainers = containers.map((container, index) => {
      if (index === currentContainer) {
        const existingItemIndex = container.items.findIndex(
          (item) => item.product._id === newItem.product._id
        );

        if (existingItemIndex >= 0) {
          // Update existing item quantity
          const updatedItems = [...container.items];
          updatedItems[existingItemIndex].quantity += newItem.quantity;
          return { ...container, items: updatedItems };
        } else {
          // Add new item
          return { ...container, items: [...container.items, newItem] };
        }
      }
      return container;
    });

    setContainers(updatedContainers);
    setProduct(null);
    setLocalQuantity(""); // ✅ Reset local quantity
  };

  // ✅ NEW: Remove product from container
  const removeProductFromContainer = (containerIndex, productIndex) => {
    const updatedContainers = containers.map((container, index) => {
      if (index === containerIndex) {
        const updatedItems = container.items.filter(
          (_, itemIndex) => itemIndex !== productIndex
        );
        return { ...container, items: updatedItems };
      }
      return container;
    });
    setContainers(updatedContainers);
  };

  // ✅ NEW: Submit shipment with containers
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate containers
    const validContainers = containers.filter(
      (container) =>
        container.containerNumber &&
        container.vessel &&
        container.items.length > 0
    );

    if (validContainers.length === 0) {
      alert("Please add at least one container with products");
      return;
    }

    // Prepare data for submission
    const shipmentData = {
      ...formData,
      containers: validContainers.map((container) => ({
        containerNumber: container.containerNumber,
        sealNumber: container.sealNumber,
        vessel: container.vessel,
        items: container.items.map((item) => ({
          product: item.product._id,
          quantity: item.quantity,
        })),
      })),
    };

    props.data.psData(e, shipmentData);
  };

  return (
    <div className={shipmentStylez.card}>
      <form onSubmit={handleSubmit} className={shipmentStylez.form}>
        {/* Shipment Level Fields */}
        <div className={shipmentStylez.shipmentSection}>
          <h3 className={shipmentStylez.sectionTitle}>
            📋 Shipment Information
          </h3>
          <div className={shipmentStylez.formGrid}>
            <div className={shipmentStylez.formGroup}>
              <label>BL Number *</label>
              <input
                type="text"
                name="blNumber"
                value={formData.blNumber}
                onChange={handleInput}
                required
              />
            </div>
            <div className={shipmentStylez.formGroup}>
              <label>Main Vessel</label>
              <input
                type="text"
                name="Vessel"
                value={formData.Vessel}
                onChange={handleInput}
                placeholder="Primary vessel name"
              />
            </div>
            <div className={shipmentStylez.formGroup}>
              <label>ETD *</label>
              <input
                type="date"
                name="etd"
                value={formData.etd}
                onChange={handleInput}
                required
              />
            </div>
            <div className={shipmentStylez.formGroup}>
              <label>ETA *</label>
              <input
                type="date"
                name="eta"
                value={formData.eta}
                onChange={handleInput}
                required
              />
            </div>
            <div className={shipmentStylez.formGroup}>
              <label>Unload Date *</label>
              <input
                type="date"
                name="unloadDate"
                value={formData.unloadDate}
                onChange={handleInput}
                required
              />
            </div>
          </div>
        </div>

        {/* Containers Section */}
        <div className={shipmentStylez.containersSection}>
          <div className={shipmentStylez.containerHeader}>
            <h3 className={shipmentStylez.sectionTitle}>
              🚢 Containers ({containers.length})
            </h3>
            <button
              type="button"
              onClick={addContainer}
              className={shipmentStylez.addContainerBtn}
            >
              ➕ Add Container
            </button>
          </div>

          {/* Container Tabs */}
          <div className={shipmentStylez.containerTabs}>
            {containers.map((container, index) => (
              <button
                key={container.id}
                type="button"
                className={`${shipmentStylez.containerTab} ${
                  currentContainer === index ? shipmentStylez.activeTab : ""
                }`}
                onClick={() => setCurrentContainer(index)}
              >
                Container {index + 1}
                {containers.length > 1 && (
                  <span
                    className={shipmentStylez.removeTabBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      removeContainer(index);
                    }}
                  >
                    ×
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* Current Container Form */}
          {containers[currentContainer] && (
            <div className={shipmentStylez.containerForm}>
              <div className={shipmentStylez.containerInfo}>
                <div className={shipmentStylez.formGrid}>
                  <div className={shipmentStylez.formGroup}>
                    <label>Container Number *</label>
                    <input
                      type="text"
                      value={containers[currentContainer].containerNumber}
                      onChange={(e) =>
                        handleContainerChange(
                          currentContainer,
                          "containerNumber",
                          e.target.value
                        )
                      }
                      placeholder="e.g., ABCD1234567"
                      required
                    />
                  </div>
                  <div className={shipmentStylez.formGroup}>
                    <label>Seal Number</label>
                    <input
                      type="text"
                      value={containers[currentContainer].sealNumber}
                      onChange={(e) =>
                        handleContainerChange(
                          currentContainer,
                          "sealNumber",
                          e.target.value
                        )
                      }
                      placeholder="Seal number"
                    />
                  </div>
                  <div className={shipmentStylez.formGroup}>
                    <label>Vessel *</label>
                    <input
                      type="text"
                      value={containers[currentContainer].vessel}
                      onChange={(e) =>
                        handleContainerChange(
                          currentContainer,
                          "vessel",
                          e.target.value
                        )
                      }
                      placeholder="Vessel name for this container"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Product Addition Section */}
              <div className={shipmentStylez.productSection}>
                <h4 className={shipmentStylez.productTitle}>
                  📦 Add Products to Container {currentContainer + 1}
                </h4>
                <div className={shipmentStylez.productForm}>
                  <div className={shipmentStylez.formGroup}>
                    <label>Product</label>
                    <select
                      value={product?._id || ""}
                      onChange={(e) => {
                        const selectedProduct = props.data.prodOptions?.find(
                          (p) => p._id === e.target.value
                        );
                        setProduct(selectedProduct);
                      }}
                    >
                      <option value="">Select a product</option>
                      {props.data.prodOptions?.map((prod) => (
                        <option key={prod._id} value={prod._id}>
                          {prod.productName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={shipmentStylez.formGroup}>
                    <label>Quantity</label>
                    {/* ✅ UPDATED: Use local quantity state */}
                    <input
                      type="number"
                      value={localQuantity}
                      onChange={(e) => setLocalQuantity(e.target.value)}
                      min="1"
                      placeholder="Enter quantity"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={addProductToContainer}
                    className={shipmentStylez.addProductBtn}
                    disabled={!product || !localQuantity || localQuantity <= 0}
                  >
                    ➕ Add Product
                  </button>
                </div>
              </div>

              {/* Container Products List */}
              <div className={shipmentStylez.productsTable}>
                <h4 className={shipmentStylez.productTitle}>
                  Products in Container {currentContainer + 1} (
                  {containers[currentContainer].items.length})
                </h4>
                {containers[currentContainer].items.length === 0 ? (
                  <div className={shipmentStylez.emptyProducts}>
                    No products added to this container yet
                  </div>
                ) : (
                  <table className={shipmentStylez.table}>
                    <thead>
                      <tr>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {containers[currentContainer].items.map((item, index) => (
                        <tr key={index}>
                          <td>{item.product.productName}</td>
                          <td>{item.quantity}</td>
                          <td>{item.product.unit}</td>
                          <td>
                            <button
                              type="button"
                              onClick={() =>
                                removeProductFromContainer(
                                  currentContainer,
                                  index
                                )
                              }
                              className={shipmentStylez.removeBtn}
                            >
                              🗑️ Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Summary Section */}
        <div className={shipmentStylez.summary}>
          <h4 className={shipmentStylez.summaryTitle}>📊 Shipment Summary</h4>
          <div className={shipmentStylez.summaryStats}>
            <div className={shipmentStylez.stat}>
              <span className={shipmentStylez.statLabel}>
                Total Containers:
              </span>
              <span className={shipmentStylez.statValue}>
                {containers.length}
              </span>
            </div>
            <div className={shipmentStylez.stat}>
              <span className={shipmentStylez.statLabel}>Total Products:</span>
              <span className={shipmentStylez.statValue}>
                {containers.reduce(
                  (total, container) => total + container.items.length,
                  0
                )}
              </span>
            </div>
            <div className={shipmentStylez.stat}>
              <span className={shipmentStylez.statLabel}>Total Quantity:</span>
              <span className={shipmentStylez.statValue}>
                {containers.reduce(
                  (total, container) =>
                    total +
                    container.items.reduce(
                      (containerTotal, item) => containerTotal + item.quantity,
                      0
                    ),
                  0
                )}
              </span>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className={shipmentStylez.btnStyle}>
          <button type="submit" className="confirmBtn">
            🚢 Create Shipment
          </button>
        </div>
      </form>
    </div>
  );
};
export default memo(ShipmentCard);
